import React from 'react';
import { useNavigate } from 'react-router-dom';

const HeroContent: React.FC = () => {
  const navigate = useNavigate();

  // Navigation functions
  const handleGlobalIntranetClick = () => {
    window.open('https://aosmithcorporation.sharepoint.com/', '_blank');
  };
  const handleEmployeeDirectoryClick = () => {
    window.open('https://performancemanager8.successfactors.com/sf/directory?company=aosmith&_s.crb=3Bp%252bU9r3HFZsw4GBdA3nFR8NTcpzLCDjRkz%252brjNM9mk%253d', '_blank');
  }
  const handlePoliciesClick = () => navigate('/policies');
  const handlePeopleOnMoveClick = () => navigate('/people-on-move');

  const buttonClasses =
    "group flex items-center  gap-2  border-[2px] border-white text-white rounded-lg hover:bg-white hover:text-gray-800 transition-all duration-300  font font-poppins min-h-[60px] w-full px-3 sm:px-2 md:px-4 lg:px-4 xl:px-4";

  return (
    <div className=" justify-center w-full h-auto ">
      {/* Wider container that adapts with screen size */}
      <div className="grid grid-cols-1 gap-4 sm:gap-10 w-full max-w-md sm:max-w-lg md:max-w-xl lg:max-w-2xl xl:max-w-3xl ">
        {/* Global Intranet */}
        <button onClick={handleGlobalIntranetClick} className={buttonClasses}>
          <img
            src="assets/internet.svg"
            alt="internet"
            className="w-9 h-9 flex-shrink-0 filter brightness-0 invert group-hover:invert-0 transition-all duration-300 "
          />
          <span className="text-sm sm:text-base font-medium">Global Intranet</span>
        </button>

        {/* India Emp Directory */}
        <button onClick={handleEmployeeDirectoryClick} className={buttonClasses}>
          <img
            src="assets/users.svg"
            alt="users"
            className="w-9 h-9 flex-shrink-0 filter brightness-0 invert group-hover:invert-0 transition-all duration-300"
          />
          <span className="text-sm sm:text-base font-medium ">Employee Directory</span>
        </button>

        {/* Policies */}
        <button onClick={handlePoliciesClick} className={buttonClasses}>
          <img
            src="assets/document.svg"
            alt="document"
            className="w-9 h-9 flex-shrink-0 filter brightness-0 invert group-hover:invert-0 transition-all duration-300"
          />
          <span className="text-sm sm:text-base font-medium">Policies</span>
        </button>

        {/* People on the Move - Disabled */}
        <button disabled className={buttonClasses}>
          <img
            src="assets/user-plus.svg"
            alt="user plus"
            className="w-9 h-9 flex-shrink-0 filter brightness-0 invert  group-hover:invert-0  opacity-50"
          />
          <span className="text-sm sm:text-base font-medium opacity-50">People on the Move</span>
        </button>
      </div>
    </div>
  );
};

export default HeroContent;
